import Spinning from 'app/components/Spinning'
import Confirmation from 'app/components/Confirmation'

export default ({
  className,
  children,
  onConfirm,
  Trigger,
  isSpinning = false,
  inlineLabel = false,
  enabled = true,
  confirmation = 'Are you sure?',
  size = 'md'
}) => {
  const [isConfirming, setIsConfirming] = useState(false)

  const confirm = useCallback((e) => {
    if (isSpinning || !enabled) return
    setIsConfirming(true)
  })

  const cancel = useCallback((e) => {
    if (isSpinning) return
    setIsConfirming(false)
  })

  if (isSpinning) return <Spinning className="text-xl" />

  const outerClassName = clsx('btn-confirmable', {
    'btn-confirmable-confirming': isConfirming,
    'btn-confirmable-xs': size == 'xs'
  })

  return (
    <div className="btn-confirmable-wrapper">
      <div className={outerClassName}>
        {Trigger ? (
          <div className={`btn-confirmable-child ${className}`}>
            {children}
            <Trigger onClick={confirm} />
          </div>
        ) : (
          <div
            className={`btn-confirmable-child ${className}`}
            onClick={confirm}
          >
            {children}
          </div>
        )}
        <Confirmation
          onConfirm={onConfirm}
          cancel={cancel}
          size={size}
          confirmation={confirmation}
        />
      </div>
    </div>
  )
}
